<template>
  <div class="StockDetailsPopupPage">
    <div class="StockDetailsPopup">
      <el-dialog :visible="localDialogVisible" @close="closeDialog" :class="['custom-dialog']">
        <div class="section">
          <div class="first-section">
            <div class="reco-date-container">
              <div class="reco-date">
                <span>Reco date:</span>
                {{ moment(reco_data.created_at).format('MMM D, YYYY, hh:mm A') + ' IST' }}
              </div>
            </div>
            <div class="duration-container">
              <div class="duration" v-if="reco_data.duration">{{ reco_data.duration.replace(/_/g, ' ') }}</div>
              <!-- <img src="../assets/images/bookmark (3).svg" class="watchlist-icon" alt="Arrow Icon" /> -->

              <img class="watchlist-icon cursor-pointer" v-if="!reco_data.is_reco_subscribe_for_notification" src="../assets/images/bookmark (3).svg" alt="" v-on:click="followReco(reco_data.id, 'FOLLOW')" />
              <img class="watchlist-icon cursor-pointer" v-else src="../assets/images/Filled bookmark.svg" alt="" v-on:click="followReco(reco_data.id, 'UNFOLLOW')" />
            </div>
          </div>
        </div>

        <!-- Section 1: Stock Info -->
        <div class="section stock-info">
          <div class="left">
            <div class="stock-name">
              {{ reco_data.stock.name || '' }}
            </div>
            <div class="price" v-if="reco_data.stock.current_price">
              <span style="margin-right: 5px">₹ {{ reco_data.stock.current_price }}</span>
              <span class="stock-section-inc" :style="[reco_data.stock.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
                <span style="font-size: 18px" v-if="reco_data.stock.price_difference >= 0">&#9652;</span>
                <span style="font-size: 18px" v-else>&#9662;</span>
                {{ reco_data.stock.price_difference }} ({{ reco_data.stock.potential_difference }}%)
              </span>
            </div>
            <div class="input-label-gray top-margin-5" v-if="reco_data.stock.current_datetime">
              {{ moment(reco_data.stock.current_datetime).format('MMM D, YYYY, hh:mm A') + ' IST' }}
            </div>
          </div>

          <div class="right">
            <div class="target-label">Remaining Target</div>
            <div class="target-value">
              <span>
                <span v-if="reco_data.reco_status == 'YET TO LIVE'">{{ reco_data.max_profit_in_percentage }}%</span>
                <span v-else-if="reco_data.reco_status == 'TARGET ACHIEVED'">0%</span>

                <span v-else>{{ !reco_data.potential_as_of_current_date ? 0 : reco_data.potential_as_of_current_date }}%</span>
              </span>
            </div>
          </div>
        </div>

        <!-- Section 2 -->
        <div class="section">
          <StockProgress :stockData="reco_data" :segment="'Equity'"></StockProgress>
        </div>

        <!-- Section 3 -->
        <div class="section">
          <div class="image-container">
            <div class="image-item left">
              <img src="../assets/images/Stock Analysis.svg" alt="Stock Analysis" @click="openPopupForMoreDetails(reco_data)" />
              <div class="label">Stock Analysis</div>
            </div>
            <div class="partation-line"></div>
            <div class="image-item middle">
              <!-- <img src="../assets/images/Expert Logic.svg" alt="Expert Logic" /> -->

                <el-popover
  placement="bottom"
  trigger="click"
  width="300"
  popper-class="custom-popover-shadow"
  style="margin-bottom: 4px"
>
  <img
    class="info-Logo cursor-pointer"
    src="../assets/images/Logic.svg"
    alt
    slot="reference"
  />

  <div class="recommendation-details">
    <el-collapse v-model="activeLogicSections" accordion>
      <!-- Discovery Category & Logic -->
      <el-collapse-item name="1" title="Discovery Category & Logic">
        <div
          v-if="reco_data.category_stamp && reco_data.category_stamp.length"
          style="border-bottom:1px solid rgb(231, 231, 231); margin-bottom: 10px; padding-top: 5px;"
        >
          <div class="section-subtitle">Category</div>
          <div class="category-list">
            <span
              v-for="(stamp, index) in reco_data.category_stamp"
              :key="index"
              class="category-chip"
            >
              {{ stamp }}
            </span>
          </div>
        </div>

        <div
          v-if="reco_data.report && reco_data.report.some(item => item.files && item.files.length)"
        >
          <div
            v-for="(item, item_index) in reco_data.report"
            :key="item_index"
          >
            <div
              v-for="(attachment, attachment_index) in item.files"
              :key="attachment_index"
              class="attachment-block"
            >
              <div class="attachment-header">
                <div class="attachment-title">
                  Attachments {{ attachment_index + 1 }}
                </div>
                <div
                  class="download-link"
                  @click="downloadAttachment(attachment)"
                >
                  <i class="el-icon-download"></i> Download
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="reco_data.logic_description || (reco_data.logic_tags && reco_data.logic_tags.length)"
          class="section-block"
          :style="(reco_data.edit_description || reco_data.exit_description) ? 'border-bottom:1px solid rgb(231, 231, 231); padding-bottom: 10px; padding-top: 5px;' : 'padding-bottom: 10px; padding-top: 5px;'"
        >
          <div class="section-subtitle">Logic</div>
          <div class="logic-description">
            {{ reco_data.logic_description }}
          </div>
          <div
            class="logic-tags"
            v-if="reco_data.logic_tags && reco_data.logic_tags.length"
          >
            <span
              v-for="(tag, i) in reco_data.logic_tags"
              :key="i"
              class="logic-tag"
            >
              {{ tag }}
            </span>
          </div>
        </div>
      </el-collapse-item>

      <!-- Updated Logic -->
      <el-collapse-item
        name="2"
        title="Updated Logic"
        v-if="reco_data.edit_description"
      >
        <div class="section-block">
          <div class="logic-description">
            {{ reco_data.edit_description }}
          </div>
        </div>
      </el-collapse-item>

      <!-- Exit Logic -->
      <el-collapse-item
        name="3"
        title="Exit Logic"
        v-if="reco_data.exit_description"
      >
        <div class="section-block">
          <div class="logic-description">
            {{ reco_data.exit_description }}
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</el-popover>
              <div class="label">Expert Logic</div>
            </div>
            <div class="partation-line"></div>
            <div class="image-item right">
              <!-- <img src="../assets/images/Brokerage Cal.svg" alt="Brokerage Calculator" /> -->
              <el-popover v-if="reco_data.brokerage_data && !currentEnvironment.byPassLogin && currentEnvironment.loginModule != 'BlinkX'" popper-class="brokerage-calculator-popover" placement="bottom" width="240" trigger="click">
                <img class="info-Logo cursor-pointer" src="../assets/images/Brokrage Calculator.svg" alt slot="reference" />

                <div class="brokerageCalculator" v-loading="reco_data.brokerage_loader">
                  <div class="flex-space-between retail-tabs">
                    <div @click="selectBrokerageDetails('IntraDay')" :class="reco_data.brokerage_list_type == 'IntraDay' ? 'invester-btn' : 'navbar-menu'">IntraDay</div>
                    <div @click="selectBrokerageDetails('Delivery')" :class="reco_data.brokerage_list_type == 'Delivery' ? 'invester-btn' : 'navbar-menu'">Delivery</div>
                  </div>
                  <table class="custom-element-ui-table" v-if="reco_data.selected_brokerage_list">
                    <thead>
                      <tr>
                        <th style="width: 150px">Trading Tax</th>
                        <th style="width: 90px; text-align: center">Prices(in ₹)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{ userProfile.utm_source == 'HDFC Sky' ? 'Brokerage' : 'Brokerage for buy' }}
                        </td>
                        <td style="text-align: center">
                          <span v-if="userProfile.utm_source != 'GCL'">
                            {{ reco_data.selected_brokerage_list.buy_brokerage }}
                          </span>
                          <div class="edit-brokerage-input" v-else>
                            <el-input-number :controls="false" placeholder="Buy brokerage" v-model="reco_data.selected_brokerage_list.buy_brokerage" @change="calculateBrokerageData()" style="width: 80px"></el-input-number>
                            <span style="position: absolute; right: 6px">
                              <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="userProfile && userProfile.utm_source != 'HDFC Sky'">
                        <td>Brokerage for Sell</td>
                        <td style="text-align: center">
                          <span v-if="userProfile.utm_source != 'GCL'">
                            {{ reco_data.selected_brokerage_list.sell_brokerage }}
                          </span>
                          <span v-else>
                            <div class="edit-brokerage-input">
                              <el-input-number :controls="false" placeholder="Sell brokerage" v-model="reco_data.selected_brokerage_list.sell_brokerage" @change="calculateBrokerageData()" style="width: 80px"></el-input-number>
                              <span style="position: absolute; right: 6px">
                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                              </span>
                            </div>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>STT</td>
                        <td style="text-align: center">
                          {{ reco_data.selected_brokerage_list.stt }}
                        </td>
                      </tr>
                      <tr>
                        <td>Transaction Charge</td>
                        <td style="text-align: center">
                          {{ reco_data.selected_brokerage_list.exchange_txn_charge }}
                        </td>
                      </tr>
                      <tr>
                        <td>GST</td>
                        <td style="text-align: center">
                          {{ reco_data.selected_brokerage_list.gst }}
                        </td>
                      </tr>
                      <tr>
                        <td>Stamp Duty</td>
                        <td style="text-align: center">
                          {{ reco_data.selected_brokerage_list.stamp_duty }}
                        </td>
                      </tr>
                      <tr>
                        <td>SEBI Charges</td>
                        <td style="text-align: center">
                          {{ reco_data.selected_brokerage_list.sebi_charges }}
                        </td>
                      </tr>
                      <tr v-if="userProfile && userProfile.utm_source == 'Zebu'">
                        <td>Cm Charges</td>
                        <td style="text-align: center">
                          {{ reco_data.selected_brokerage_list.cm_charges }}
                        </td>
                      </tr>
                      <tr class="font-weight-600" style="color: #636161; font-size: 12px">
                        <td>Total Tax & Charges</td>
                        <td style="text-align: center">
                          {{ reco_data.selected_brokerage_list.total_tax_and_charges }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="flex-space-between">
                    <div>
                      <label class="input-label block bottom-margin-5 top-margin-20">Quantity</label>

                      <el-input-number v-model="reco_data.reco_quantity" controls-position="right" @change="calculateBrokerageData()" size="mini" style="width: 100px" :min="1"></el-input-number>
                    </div>

                    <div>
                      <label class="input-label block bottom-margin-5 top-margin-20">Exp. Tax</label>

                      <div style="padding: 2px 5px; border: 1px solid #c0c4cc; border-radius: 4px; text-align: center">
                        {{ reco_data.exp_tax }}
                      </div>
                    </div>
                  </div>

                  <div class="required-field font-06rem font-weight-600 top-margin-10" style="padding: 0 8px">Note: The above charges are tentative. Please refer broker's contract note for exact charges.</div>
                </div>
              </el-popover>
              <div class="label">Brokerage Calculator</div>
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="button-container">
          <button class="custom-button ask-expert" @click="$router.push('/expert-list')">
            <img src="../assets/images/chat.svg" alt="chat-icon" />
            Chat
          </button>
          <!-- <button class="custom-button buy" :disabled="true" :style="{ backgroundColor: getButtonColor(reco_data.reco) }">
            <img style="width: 14px; position: relative" src="../assets/images/two-arrows.png" alt="" />
            {{ reco_data.reco }}
          </button> -->

          <!-- <div> -->
          <button class="custom-button buy" :style="{ backgroundColor: getButtonColor(reco_data.reco) }" @click.stop="openStockPopup(reco_data, 'trade')" v-if="userProfile && !currentEnvironment.byPassLogin && !currentEnvironment.isStockAntsAuth && userProfile.utm_source != 'Fyers' && userProfile.utm_source != 'BlinkX' && userProfile.utm_source != 'AngelOne' && userProfile.utm_source != '5 Paisa' && userProfile.utm_source != 'Dhan' && userProfile.utm_source != 'Finvasia' && userProfile.utm_source != 'Zerodha'">
            <img style="width: 14px; position: relative" src="../assets/images/two-arrows.png" alt="" />
            {{ reco_data.reco }}
          </button>

          <button class="custom-button buy" :style="{ backgroundColor: getButtonColor(reco_data.reco) }" @click.stop="getTradeHostDetails()" v-else-if="currentEnvironment.byPassLogin && currentEnvironment.isHybridModel">
            {{ reco_data.reco }}
          </button>

          <button class="custom-button buy" :style="{ backgroundColor: getButtonColor(reco_data.reco) }" style="cursor: not-allowed" @click.stop="" v-else>
            {{ reco_data.reco }}
          </button>
          <!-- </div> -->
        </div>

        <!-- Expert and Risk Level -->
        <div class="expert-risk-container">
          <div class="expert-info">
            <div class="cursor-pointer flex" @click="goToExpertStore(reco_data.user)">
              <img v-if="!reco_data.user.pic" src="../assets/images/navBar/avatar.jpg" class="user-profile-pic" alt />

              <img v-else :src="serverHostName + reco_data.user.pic" class="user-profile-pic" alt />
            </div>
            <span class="expert-name">{{ reco_data.user.full_name }}</span>
            <!-- <i class="el-icon-success expert-verified"></i> -->
            <el-tooltip v-if="reco_data.user.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
              <img class="info-Logo cursor-pointer" src="../assets/images/verify.svg" style="width: 16px" alt />
            </el-tooltip>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="sentiment-card-dialog tabs-dialog">
      <el-dialog :visible.sync="showSentimentCard" :before-close="clearTechnicalDataWidget">
        <div style="padding: 20px">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="Market Sentiment" name="Market Sentiment">
              <div class="tab-market-sentiment">
                <MarketSentimentCard v-if="selectedSymbol" :stock_code="selectedSymbol" :key="selectedSymbol" style="border: 1px solid #dbdbdb; border-radius: 8px"></MarketSentimentCard>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Fundamental Data" name="Fundamental Data">
              <iframe :src="'https://stocks.tickertape.in/' + selectedSymbol + '?broker=stockants'" width="100%" height="350px"></iframe>
            </el-tab-pane>
            <el-tab-pane label="Technical Data" name="Technical Data">
              <VueTradingView
                class="top-margin-15"
                v-if="selectedSymbol"
                :options="{
                  symbol: 'BSE:' + selectedSymbol,
                  theme: 'light',
                  autosize: false,
                  allow_symbol_change: true,
                  autosize: true,
                  locale: 'in',
                  style: 3,
                  interval: '1D',
                }"
                style="height: 350px"
              />
              <div class="tradingview-widget-copyright top-margin-10" v-if="selectedSymbol">
                <a href="https://in.tradingview.com/" rel="noopener nofollow" target="_blank">
                  <span class="blue-text">{{ selectedSymbol }} stock chart by TradingView</span>
                </a>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import StockProgress from './StockProgressBarComponent.vue';
import moment from 'moment';
import { serverAddr, serverHostName } from '../networkConfig';
import CripNotice from 'crip-vue-notice';
import MarketSentimentCard from '@/components/MarketSentimentCard.vue';
import Trade from '@/components/Trade.vue';
import VueTradingView from 'vue-trading-view/src/vue-trading-view';

export default {
  components: {
    StockProgress,
    MarketSentimentCard,
    Trade,
    VueTradingView,
  },
  props: {
    isStockDetailsDialogVisible: Boolean,
    reco_data: Object,
  },
  data() {
    return {
      // priceChange: 0
      serverHostName: serverHostName,
      moment: moment,
      isStockProfilePopupVisible: false,
      selectedSymbol: '',
      activeTab: 'Market Sentiment',
      showSentimentCard: false,
      currentEnvironment: {},
      activeLogicSections: '',
    };
  },
  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
    priceChangePercent() {
      return this.reco_data && this.reco_data.priceChangePercent !== undefined ? this.reco_data.priceChangePercent.toFixed(2) : '0.00';
    },
    localDialogVisible: {
      get() {
        return this.isStockDetailsDialogVisible;
      },
      set(value) {
        this.$emit('update:isStockDetailsDialogVisible', value);
      },
    },
  },

  mounted() {
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

      this.hostUrl = this.currentEnvironment.hostUrl;
    }
  },

  methods: {
    openStockPopup(reco, action) {
      this.closeDialog();
      this.$emit('get_reco_details', reco, action);
    },

    getTradeHostDetails() {
      this.closeDialog();
      this.$store.commit('commitHybridBrokerLoginDialogVisibility', true);
    },
    downloadAttachment(attachment_link) {
      if (attachment_link) {
        window.open(`${serverHostName}${attachment_link}`, '_blank');
      }
    },

    getButtonColor(reco) {
      return reco === 'Buy' ? '#0BA042' : reco === 'Sell' ? '#EA2526' : '#ffc107';
    },

    calculateBrokerageData() {
      this.$set(this.reco_data, 'brokerage_loader', true);
      var reco = this.reco_data;

      var obj = {
        reco_id: reco.id,
        quantity: reco.reco_quantity,
      };

      if (this.userProfile.utm_source == 'GCL') {
        obj.duration = reco.brokerage_list_type;
        obj.buy_brokerage = reco.selected_brokerage_list.buy_brokerage ? Number(reco.selected_brokerage_list.buy_brokerage) : 0;
        obj.sell_brokerage = reco.selected_brokerage_list.sell_brokerage ? Number(reco.selected_brokerage_list.sell_brokerage) : 0;
      }

      serverAddr
        .post('recommendation/v1/equity_brokerage_calculator', obj)
        .then((response) => {
          if (response.data.status) {
            var data = response.data.data;
            this.$set(this.reco_data, 'brokerage_data', data);

            // to set preselected type data
            this.selectBrokerageDetails(this.reco_data.brokerage_list_type);
          }
          this.$set(this.reco_data, 'brokerage_loader', false);
        })
        .catch((error) => {
          console.log(error);
          this.$set(this.reco_data, 'brokerage_loader', false);
        });
    },
    selectBrokerageDetails(option) {
      this.$set(this.reco_data, 'brokerage_loader', true);
      if (option == 'Delivery') {
        this.$set(this.reco_data, 'selected_brokerage_list', this.reco_data.brokerage_data.Delivery[0].data);
        this.$set(this.reco_data, 'brokerage_list_type', 'Delivery');
        if (this.reco_data.brokerage_data.Delivery[0].exp_tax) {
          this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.Delivery[0].exp_tax);
        } else {
          this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.Delivery[0].data.total_tax_and_charges);
        }
      } else {
        this.$set(this.reco_data, 'selected_brokerage_list', this.reco_data.brokerage_data.IntraDay[0].data);
        this.$set(this.reco_data, 'brokerage_list_type', 'IntraDay');
        if (this.reco_data.brokerage_data.IntraDay[0].exp_tax) {
          this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.IntraDay[0].exp_tax);
        } else {
          this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.IntraDay[0].data.total_tax_and_charges);
        }
      }

      setTimeout(() => {
        this.$set(this.reco_data, 'brokerage_loader', false);
      }, 200);
    },
    openPopupForMoreDetails(data) {
      this.selectedSymbol = data.stock.symbol;
      this.activeTab = 'Market Sentiment';
      this.showSentimentCard = true;
    },
    // Clear the widget content when the dialog is closed
    clearTradingViewWidget() {
      const container = this.$refs.tradingviewContainer;

      if (container) {
        container.innerHTML = ''; // Clear the widget
      }
      this.isStockProfilePopupVisible = false;
    },
    clearTechnicalDataWidget() {
      this.selectedSymbol = ''; // Clear previous symbol
      this.$nextTick(() => {
        this.selectedSymbol = ''; // for fully cleared
      });

      this.showSentimentCard = false;
      this.activeTab = 'Market Sentiment';
    },
    followReco(recoId, action) {
      serverAddr
        .post('base/v1/trigger_notification_for_trading', {
          reco_id: recoId,
          event: 'EQ_TRADE_ON_MARKET_OPINION',
          watchlist_type: action,
        })
        .then((response) => {
          if (response.data.status) {
            if (action == 'FOLLOW' || action == 'TRADE') {
              this.$set(this.reco_data, 'is_reco_subscribe_for_notification', true);

              new CripNotice({
                title: 'Success',
                description: `You followed ${this.reco_data.stock.symbol} recommendation published by ${this.reco_data.user.full_name} `,
                type: 'success',
                duration: 2,
              });
            } else {
              this.$set(this.reco_data, 'is_reco_subscribe_for_notification', false);

              new CripNotice({
                title: 'Success',
                description: `You unfollowed ${this.reco_data.stock.symbol} recommendation`,
                type: 'success',
                duration: 2,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeDialog() {
      this.localDialogVisible = false;
    },
  },
};
</script>


<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.StockDetailsPopupPage {
  .StockDetailsPopup {
    .custom-dialog {
      border-radius: 12px !important;
    }

    /* Sections Inside Dialog */
    .section {
      padding: 10px;
      border-bottom: 1px solid #e8eef5;
    }

    .user-profile-pic {
      height: 20px;
      width: 20px;
      border-radius: 50px;
      object-fit: cover;
    }

    .first-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    /* Recommendation Date */
    // .reco-date-container {
    //   display: flex;
    //   justify-content: flex-start;
    // }

    .reco-date {
      font-size: 12px;
      font-weight: 500;
      color: #000000;
      white-space: nowrap;
    }
    .reco-date span {
      font-size: 12px;
      font-weight: 500;
      color: #878787;
      white-space: nowrap;
    }

    /* Duration */
    .duration-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 5px;
    }

    .duration {
      font-size: 12px;
      font-weight: 500;
      color: #000000;
      text-transform: capitalize;
    }

    /* Watchlist Icon */
    .watchlist-icon {
      width: 25px;
    }

    /* Stock Info Section */
    .stock-info {
      display: flex;
      justify-content: space-between;
      align-items: self-start;
    }
    .image-container {
      .left {
        text-align: left;
        display: flex;
        flex-direction: column;
        // gap: 5px;
        // border-right: 2px solid gray;
      }
      .partation-line {
        border-right: 1px solid #eae8e8;
        height: 65px;
      }
    }

    .stock-name {
      font-weight: 600;
      font-size: 16px;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #000000;
    }

    .price {
      font-size: 16px;
      color: #000000;
      font-weight: 600;
    }

    .negative {
      color: #ea2526;
    }

    .positive {
      color: #0ba042;
    }

    /* Target Section */
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      // gap: 5px;
    }

    .target-label {
      font-size: 12px;
      font-weight: 500;
      color: #acacac;
      white-space: nowrap;
    }

    .target-value {
      font-size: 15px;
      font-weight: 600;
      color: #27ae60;
      background-color: #edfff4;
      border-radius: 5px;
      padding: 5px 10px;
      margin-top: 10px;
    }

    /* Image Items Section */
    .image-container {
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 10px;
    }

    .image-item {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .image-item img {
      width: 40px;
      height: 40px;
      border-radius: 8px;
    }

    .label {
      font-size: 10px;
      font-weight: 500;
      color: #000000;
      text-align: center;
      // white-space: nowrap;
    }

    /* Buttons Section */
    .button-container {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;
    }

    .custom-button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 48%;
      padding: 13px 15px;
      font-size: 12px;
      font-weight: 500;
      border-radius: 8px;
      cursor: pointer;
      border: none;
      white-space: nowrap;
    }

    .ask-expert {
      background-color: #ffffff;
      color: #2488ff;
      border: 1px solid #2488ff;
    }

    .buy {
      color: #fff;
      // cursor: not-allowed;
    }

    /* Expert Risk Section */
    .expert-risk-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px 0;
    }

    .expert-info {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .expert-photo {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }

    .expert-name {
      font-size: 12px;
      font-weight: 600;
      color: #000000;
    }

    .expert-verified {
      color: #3498db;
      font-size: 12px;
    }

    .risk-level {
      font-size: 12px;
      font-weight: 600;
      padding: 5px 10px;
      border-radius: 5px;
      text-transform: capitalize;
      .tag {
        padding: 5px 10px;
        border-radius: 4px;
      }
    }

    .high_risk {
      color: #ea2526;
      .tag {
        background: #f7cbc3;
      }
    }

    .moderate_risk {
      color: #ffc107;

      .tag {
        background: #fff9e9;
      }
    }

    .low_risk {
      color: #0ba042;
      .tag {
        background: #deffea;
      }
    }
  }

  @media screen and (max-width: 400px) {
    .StockDetailsPopup {
      .input-label-gray,
      .target-label,
      .reco-date span,
      .duration,
      .reco-date {
        font-size: 10px;
      }
      .watchlist-icon {
        width: 18px;
      }
      .target-value {
        font-size: 13px;
      }
      .stock-name {
        font-size: 15px;
      }

      .price {
        font-size: 12px;
      }

      .stock-section-inc {
        font-size: 10px;
      }
      .input-label-gray {
        margin-top: 0;
      }

      .section {
        padding: 10px 5px;
      }

      .image-item img {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.StockDetailsPopupPage {
  .StockDetailsPopup {
    .el-dialog {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      width: 620px;
      border-top: 5px solid;
      border-top-color: v-bind(riskBorderColor);
      margin-top: 10px !important;

      .el-dialog__body {
        padding: 10px 10px;
      }

      .el-dialog__header {
        padding: 10px;
        background: #ffff;
        border-bottom: none;
        border-radius: 12px;
      }
      .el-dialog__wrapper {
        bottom: 0;
      }
      .el-dialog__headerbtn {
        top: 10px;
        right: 12px;
        // padding: 5px 5px 4px 5px;
        // border-radius: 50%;
        // background: #e7e7e7;
      }
      .el-dialog__headerbtn .el-dialog__close {
        color: #000000;
        font-weight: 600;
      }
    }
  }
  .sentiment-card-dialog {
    .tab-market-sentiment {
      .stock-details {
        margin: 15px;
      }

      .sentiment-options {
        display: none;
      }

      .el-card__body,
      .el-main {
        padding: 0;
      }

      .box-card {
        margin: 0;
      }
    }

    .el-dialog {
      margin-top: 100px;
      width: 550px;
      border-radius: 8px;
    }

    .el-dialog__body,
    .el-dialog__header {
      padding: 0px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      z-index: 2;
      position: relative;
    }

    .box-card {
      border-radius: 10px !important;
      border: none;
      box-shadow: none;
    }

    .box-card-two {
      margin: 5px;
    }

    .employee-select-box .el-input--mini .el-input__inner {
      height: 25px;
      border-radius: 8px;
      text-transform: capitalize;
    }

    .el-progress-bar {
      padding: 0;
    }

    .el-progress__text {
      display: none;
    }

    .vuejs-countdown .digit {
      font-size: 28px;
    }

    .el-checkbox__inner {
      border-radius: 4px;
    }
  }

 .recommendation-details {
  .el-collapse-item__header {
    font-weight: 600;
    font-size: 14px;
    padding: 12px;
    background: #fff;
    border-bottom: 1px solid #eee;
    border-radius: 8px;
    color: #000;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    border-bottom:1px solid rgb(231, 231, 231) !important;

    .el-collapse-item__arrow {
      margin-left: auto !important;
      font-size: 14px !important;
      color: #909399 !important;
      transition: transform 0.3s ease !important;
      display: inline-block !important;
    }

    &.is-active .el-collapse-item__arrow {
      transform: rotate(90deg) !important;
    }
  }

  .section-subtitle {
    font-weight: 600;
    font-size: 13px;
    padding-left: 12px;
    color: #000;
    margin-bottom: 8px;
  }

  .category-list {
    display: flex;
    flex-wrap: wrap;
  }

  .category-chip {
    background: #fff;
    border-radius: 20px;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 500;
    margin: 0 10px 10px 12px;
    color: black;
    border: 1px solid #ccc;
  }

  .attachment-block {
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 6px;
    margin-bottom: 12px;
  }

  .attachment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 12px;
  }

  .attachment-title {
    font-size: 13px;
    font-weight: 600;
    color: #000;
  }

  .download-link {
    font-size: 13px;
    color: #ef3f3f;
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      margin-right: 4px;
      font-size: 0.75rem;
    }
  }

  .logic-description {
    font-size: 13px;
    color: #555;
    max-height: 100px;
    overflow-y: auto;
    margin: 5px 0 12px;
    padding-left: 12px;
  }

  .logic-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding-left: 12px;
  }

  .logic-tag {
    background-color: #ef3f3f;
    color: white;
    border-radius: 20px;
    padding: 3px 10px;
    font-size: 11px;
    font-weight: 700;
  }

  .section-block {
    // optional padding
  }
}
  @media screen and (max-width: 630px) {
    .StockDetailsPopup {
      .el-dialog {
        width: 95%;
        .el-dialog__headerbtn {
          top: 8px;
          right: 10px;
          padding: 0;
          border-radius: 0;
          background: transparent;
        }
        .el-dialog__header {
          padding: 5px;
        }
      }
    }
    .sentiment-card-dialog {
      .el-dialog {
        margin-top: 20px;
        width: 95%;
      }
    }
  }
  @media screen and (max-width: 400px) {
    .StockDetailsPopup {
      .el-dialog {
        .el-dialog__body {
          padding: 10px 7px;
        }
      }

      .label {
        font-size: 9px;
      }

      .max-profit-loss-section .profit-loss-blocks {
        font-size: 10px;
        span {
          margin-left: 0;
        }
      }
      .progress-bar-inner {
        span {
          font-size: 10px;
        }
      }
    }
  }
}
</style>


